export default __webpack_public_path__ + "static/about-0e689df447ece6b18031d9620e406859.mp4";